<template>
  <div>
      <div class="top-message">
        <van-icon name="smile" color="#FEB013" size="100px" />
        <div>已扫码登记，感谢~</div>
      </div>
      <van-image :src="require('../../assets/jpg_empty.png')" class="bottom-img" />
  </div>
</template>

<script>
export default {
  props: {
    msg: String
  }
}
</script>

<style>
#app {
  height: auto;
  background: #FFFFFF;
}
.top-message{
  width: 100%;
  text-align: center;
  position: absolute;
  margin: 40% 0;
}

.bottom-img{
  position: fixed;
  bottom: 0;
}
</style>
